<template>
    <!-- 加粗设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
  <div class="setting-item">
    <el-form-item label="是否加粗"> 
      <el-radio-group v-model="strong" size="small">
        <el-radio-button v-for="(item,index) in strongConfigList(value.type)"
                         :key="index" 
                         :label="item.label">
                         {{item.value}}</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入加粗配置文件
import { strongConfigList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 加粗
     *  @description 将 strong 字段映射到当前 strong 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      strong: { 
        parent: i => i.renderOption,
        attr: "strong" 
      }
    })
  },
  methods: {
    strongConfigList
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderStrong.vue